import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const EditWorkflowForm = withSafeSuspense(lazy(
  async () => ({ default: (await import('./edit')).EditWorkflowForm })
))
